import { Component, OnInit } from "@angular/core";
import { CertificadosService } from "src/app/recogidas/_search/services/certificados.service";
@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false
})
export class HeaderComponent implements OnInit {
  public isGestor = 0;
  public esAgenteExterno = 0;
  public isMaqs = 0;
  public certificadosDisponibles = false;
  constructor(private certificadosService: CertificadosService) {}

  ngOnInit() {
    this.isGestor = parseInt(localStorage.getItem("isGestor"));
    this.esAgenteExterno = parseInt(localStorage.getItem("esAgenteExterno"));
    var maqs = localStorage.getItem("maqs");
    if (maqs != null && maqs.length > 0 && maqs != "null" && maqs!="undefined") {
      this.isMaqs = 1;
    }
    this.certificadosService.disponibles$().subscribe(disponibles => this.certificadosDisponibles = disponibles, () => this.certificadosDisponibles = false);

  }
  public salir() {
    localStorage.clear();
  }
  public cambiarColor(tabla) {
    /* var pantalla = localStorage.getItem('pantallaActiva');
     if (pantalla == 'pedidos') {
       document.getElementsByClassName("pedidos");
 //background: #f9b700;
     }*/
    var pantalla = localStorage.getItem("pantallaActiva");
    let styles = {};

    if (tabla == pantalla) {
      styles = {
        "background-color": "#f9b700",
      };
    }
    return styles;
  }
}
